<template>
  <span>*</span>
</template>

<script>
export default {
  name: 'ElTipasIcon',
  props: {
    classP: String,
    disabled: Boolean,
    loading: Boolean,
    active: Boolean,
    icon: String,
    type: String,
  },
}
</script>

<style lang="scss" scoped>
span {
  color: red;
}
</style>
